import React from 'react'
import '../../styles/footer.css'
import logo from '../../assets/img/logo.png'

const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer className='footer' data-aos='fade-up' data-aos-duration='1500'>
      <div className='container'>
        <div className='footer_wrapper'>

          {/* <div className='footer_box'>
            <h4 className='footer_title'>Company</h4>
            <ul className='footer_links'>
              <li>
                <a href='#'>Our programs</a>
              </li>
              <li>
                <a href='#'>Our plans</a>
              </li>
              <li>
                <a href='#'>Become a member</a>
              </li>
            </ul>
          </div>

          <div className='footer_box'>
            <h4 className='footer_title'>Quick Links</h4>
            <ul className='footer_links'>
              <li>
                <a href='#'>About Us</a>
              </li>
              <li>
                <a href='#'>Contact us</a>
              </li>
              <li>
                <a href='#'>Support</a>
              </li>
            </ul>
          </div>

          <div className='footer_box'>
            <h4 className='footer_title'>Quick Links</h4>
            <ul className='footer_links'>
              <li>
                <a href='#'>About Us</a>
              </li>
              <li>
                <a href='#'>Contact us</a>
              </li>
              <li>
                <a href='#'>Support</a>
              </li>
            </ul>
          </div> */}
        </div>

        <p className='copyright'>
          Copyright - {year} developed by <a href='#'>Techinnoveta.</a> All rights
          reserved.
        </p>
      </div>
    </footer>
  )
}
export default Footer
